
export enum ClimateControlStates {
    IDLE = 'Idle',
    HEATING = 'Heating',
    COOLING = 'Cooling'
}

export interface DisplayInfoSubIcon {
    conditionalCls?: IConditionalCls[];
    icon?: string;
    materialIcon?: string;
}

export interface IDisplayInfoIcon extends DisplayInfoSubIcon {
    getLabelText: () => string;
    getUnits?: () => string;
    isLabelVisible: () => boolean;
    getValue: () => string;
    getSubIcon?: () => undefined | DisplayInfoSubIcon;
}

export interface IConditionalCls {
    cls: string;
    condition: () => boolean;
}
